import React from 'react';
import { Table, Button } from 'antd';
import numeral from 'numeral';
import {setUpColumnObject, setupOverviewData} from '../../utils/utils';

export class EconomicModelTable extends React.Component {
  state = {
    sortedInfo: null,
  };

  handleChange = (pagination, filters, sorter) => {
    //console.log('Various parameters', pagination, filters, sorter);
    this.setState({
      sortedInfo: sorter,
    });
  }

  clearAll = () => {
    this.setState({
      sortedInfo: null,
    });
  }

  render() {
    let { sortedInfo } = this.state;
    sortedInfo = sortedInfo || {};

    const columns = [
      setUpColumnObject('Industries', 'impacted', sortedInfo, true, 460),
      setUpColumnObject('Multiplier', 'multiplier', sortedInfo, false, 140),
      setUpColumnObject('Indirect Impact', 'indirect', sortedInfo, false, 200),

    ];

    //const dataSource = setupOverviewData(this.props.data);
    const dataSource = (this.props.data);
    //console.log('dataSource', dataSource)

    return (
      <div className="table economic-model-table">
        <Table scroll={{ y: 800 }} size="small" bordered={true} pagination={false} rowKey={record => record.index} 
        columns={columns} dataSource={dataSource} onChange={this.handleChange} />
      </div>
    );
  }
}

export default EconomicModelTable;



// WEBPACK FOOTER //
// ./src/components/economicModel/EconomicModelTable.js